@if (isNewRecord() && !(consumerError() || subjectError())) {
<h2
    mat-dialog-title
    class="cut-long-text"
>{{ "functional_help_new" | transloco }}</h2>
} @else {
<h2
    mat-dialog-title
    class="cut-long-text"
>
    {{ "functional_help" | transloco }}
    <span class="name">{{ this.data?.name }}</span> {{ "edit" | transloco }}
</h2>
}
<mat-divider></mat-divider>
<mat-dialog-content>
    <mat-tab-group id="tab-group">
        <form [formGroup]="formGroup">
            <mat-tab [label]="'edit' | transloco">
                <br />
                <div>
                    <mat-form-field>
                        <mat-label>{{ "name" | transloco }}</mat-label>
                        <input
                            matInput
                            type="text"
                            required
                            placeholder=""
                            formControlName="name"
                            name="name"
                        />
                        <mat-error>{{ checkName(formGroup.controls["name"]) }}</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>{{ "consumer" | transloco }}</mat-label>
                        <mat-select
                            formControlName="consumers"
                            (valueChange)="consumerChanged($event)"
                        >
                            @for (consumer of consumers$ | async; track consumer.id) {
                            <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                            }
                        </mat-select>
                        @if (consumerError()) {
                        <mat-error>{{ getConsumerError() }}</mat-error>
                        }
                        @if (consumerIsDeleted()) {
                        <mat-error>{{ "field_entry_not_exists" | transloco }}</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div>
                    @if (consumerIsDeleted()) {
                    <br />
                    }
                    <mat-form-field>
                        <mat-label>{{ "subject_job" | transloco }}</mat-label>
                        <mat-select
                            formControlName="subjects"
                            (valueChange)="competencyChanged($event)"
                        >
                            @for (subject of subjects$ | async; track subject.id) {
                            <mat-option [value]="subject.id">{{ subject.name }}</mat-option>
                            }
                        </mat-select>
                        @if (competencyIsDeleted()) {
                        <mat-error>{{ "field_entry_not_exists" | transloco }}</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div>
                    @if (competencyIsDeleted()) {
                    <br />
                    }
                    <pixl-type-cb
                        formControlName="exerciseKind"
                        [withoutNone]="false"
                        [matLabelText]="'exercise_type' | transloco">
                    </pixl-type-cb>
                </div>
            </mat-tab>

            @if (!isNewRecord()) {
            <mat-tab [label]="'content' | transloco">
                <div class="content-container">
                    <div>{{ "text" | transloco }}</div>
                    <div>
                        <button
                            class="extend-button"
                            mat-stroked-button
                            (click)="openEditor()"
                            aria-label="Editor"
                        >{{ "editor" | transloco }}</button>
                    </div>
                    <div>
                        @if (this.data?.markupText && this.data?.markupText!.length > 0) {
                        <div class="media-container">
                            <div class="media-item">
                                <button
                                    mat-icon-button
                                    [matTooltip]="'delete_editor_content' | transloco"
                                    class="button-delete"
                                    (click)="deleteEditorContent()"
                                >
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                            <div class="pixl-editor-wrapper">
                                <div
                                    class="media-item-editor"
                                    [innerHTML]="this.viewContentHtml()"
                                ></div>
                            </div>
                        </div>
                        }
                    </div>
                </div>

                <div class="content-container">
                    <div>{{ "audio" | transloco }}</div>
                    <div>
                        <button
                            class="extend-button"
                            mat-stroked-button
                            (click)="openAudioChoice(true)"
                            aria-label="DesktopAudio"
                        >
                            <mat-icon>music_note</mat-icon>
                            {{ "audio_from_media" | transloco }}
                        </button>
                        @if (getDesktopAudioName() && getDesktopAudioName().length > 0) {
                        <div class="info cut-long-text">
                            {{ getDesktopAudioName() }}
                        </div>
                        }
                    </div>
                    <div>
                        @if (getDesktopAudioName() && getDesktopAudioName().length > 0) {
                        <div class="media-container">
                            <div class="media-item">
                                <button
                                    mat-icon-button
                                    [matTooltip]="'delete_audio_file' | transloco"
                                    class="button-delete"
                                    (click)="deleteMediaEntry(true, true)"
                                >
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                            <div class="media-item">
                                <audio
                                    #desktopAudioCtrl
                                    controls
                                    preload="auto"
                                    class="audio-control"
                                >
                                    <source
                                        src="{{ desktopAudioUrl() }}"
                                        type="audio/mpeg"
                                    />
                                    Your browser does not support the audio element.
                                </audio>
                            </div>
                        </div>
                        }
                    </div>
                </div>

                <div class="content-container">
                    <div>{{ "audio_mobile" | transloco }}</div>
                    <div>
                        <button
                            class="extend-button"
                            mat-stroked-button
                            (click)="openAudioChoice(false)"
                        >
                            <mat-icon>music_note</mat-icon>
                            {{ "audio_from_media" | transloco }}
                        </button>
                        @if (getMobileAudioName() && getMobileAudioName().length > 0) {
                        <span class="info cut-long-text">{{ getMobileAudioName() }}</span>
                        }
                    </div>
                    <div>
                        @if (getMobileAudioName() && getMobileAudioName().length > 0) {
                        <div class="media-container">
                            <div class="media-item">
                                <button
                                    mat-icon-button
                                    [matTooltip]="'delete_audio_file' | transloco"
                                    class="button-delete"
                                    (click)="deleteMediaEntry(true, false)"
                                >
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                            <div class="media-item">
                                <audio
                                    #mobileAudioCtrl
                                    controls
                                    preload="auto"
                                    class="audio-control"
                                >
                                    <source
                                        src="{{ mobileAudioUrl() }}"
                                        type="audio/mpeg"
                                    />
                                    Your browser does not support the audio element.
                                </audio>
                            </div>
                        </div>
                        }
                    </div>
                </div>

                <div class="content-container">
                    <div>{{ "image" | transloco }}</div>
                    <div>
                        <button
                            class="extend-button"
                            mat-stroked-button
                            (click)="openImageChoice()"
                        >
                            <mat-icon>add_photo_alternate</mat-icon>
                            {{ "image_from_media" | transloco }}
                        </button>
                        @if (getImageName() && getImageName().length > 0) {
                        <span class="info cut-long-text">{{ getImageName() }}</span>
                        }
                        <br />
                    </div>
                    <div>
                        @if (getImageName() && getImageName().length > 0) {
                        <div class="media-container">
                            <div class="media-item">
                                <button
                                    mat-icon-button
                                    [matTooltip]="'delete_image_file' | transloco"
                                    class="button-delete"
                                    (click)="deleteMediaEntry(false, false)"
                                >
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                            <div class="media-item">
                                <img
                                    src="{{ imageUrl() }}"
                                    alt=""
                                    class="preview"
                                />
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </mat-tab>
            }
        </form>
    </mat-tab-group>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button
        mat-raised-button
        (click)="onCancel()"
    >{{ "abort" | transloco }}</button>
    <button
        mat-raised-button
        (click)="onSave()"
        [disabled]="!formGroup.valid || approval()"
    >{{ "save" | transloco }}</button>
</mat-dialog-actions>